// extracted by mini-css-extract-plugin
export default {"btn":"CopyBtn_btn__AdTe4"};